<template>    
  <v-menu v-model="showMenu"
          :position-x="x"
          :position-y="y"
          absolute
          offset-y
    >
      <map-tool-list :uiid="uiid">
        <v-subheader>{{$t('Pilot.Tools.Title')}}<v-spacer /><v-icon>mdi-wrench</v-icon></v-subheader>                                 
        <slot></slot>
      </map-tool-list>           
    </v-menu>
</template>
<script>
  import MapToolList from '@/components/map/MapToolList'

  export default {    
    name: 'MapContextMenu',        
    components: {MapToolList},
    props:{
      uiid:{
          type: String,
          required: true,
          default: 'map_global'
      }
   },
    data() {
      return {
        showMenu: false,
        x: 0,
        y: 0
      }
    },
    methods: {       
      show (e) {
        e.preventDefault()
        this.showMenu = false
        this.x = e.clientX
        this.y = e.clientY
        this.$nextTick(() => {
          this.showMenu = true
        })
      }
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scope>

</style>
